function t(){this.__data__=[],this.size=0}export{t as default};
//# sourceMappingURL=_listCacheClear.js.map
